import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useToggle} from '@s-ui/react-hooks'
import {useLocation} from 'react-router-dom'
import ModalDisclaimer, {ModalDisclaimerIcon} from '@adv-mt/mt-modal-disclaimer'
import {PanelBasic} from '@adv-mt/mt-panel-basic'
import PanelFaqs from '@adv-mt/mt-panel-faqs'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

export const FaqsSection = ({make, model, makeModelFaqs}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const appName = config.get('APP_NAME')
  const location = useLocation()
  const {pathname, search} = location
  const [isAiDisclaimerOpen, toggleAiDisclaimer] = useToggle(false)
  const {faqs, seoFaqs = {}} = makeModelFaqs || {}
  const hasFaqs = Boolean(faqs?.items?.length)
  const stringifiedSeoFaqs = hasFaqs ? JSON.stringify(seoFaqs) : ''
  const makeModel = `${make} ${model} nuevo`
  const url = encodeURIComponent(i18n.t(`COMMON.${appName}_URL`) + pathname + search)
  const reportAiLink = i18n.t('COMMON.REPORT_AI_CONTENT_LINK', {
    url
  })

  const labelFAQs = i18n.t('MODEL_DETAIL.FAQS.TITLE', {makeModel})
  const labelFAQsMoreInfo = i18n.t('COMMON_MORE_INFO_ABOUT', {
    info: labelFAQs.toLowerCase()
  })

  return hasFaqs ? (
    <section className="mt-FaqsSection">
      <div className="mt-FaqsSection-title">
        <ModalDisclaimerIcon onClick={toggleAiDisclaimer} label={labelFAQsMoreInfo}>
          <TitleBasic as={titleBasicTags.h2} title={labelFAQs} size={titleBasicSizes.xs} />
        </ModalDisclaimerIcon>
      </div>
      <PanelBasic>
        <PanelFaqs questions={faqs?.items} faqsStructuredData={stringifiedSeoFaqs} />
      </PanelBasic>
      <ModalDisclaimer
        title={i18n.t('COMMON.INFORMATION')}
        text={i18n.t('COMMON.AI_DISCLAIMER', {
          termsAndConditionsLinkStart: `<a href="${i18n.t(
            'COMMON.TERMS_AND_CONDITIONS_SECTION_LINK.AI_GENERATED_CONTENT'
          )}" class='mt-ModalDisclaimer-link' target="_blank">`,
          termsAndConditionsLinkEnd: '</a>',
          reportAiLinkStart: `<a href="${reportAiLink}" class='mt-ModalDisclaimer-link' target="_blank">`,
          reportAiLinkEnd: '</a>'
        })}
        open={isAiDisclaimerOpen}
        onClose={toggleAiDisclaimer}
      />
    </section>
  ) : (
    <></>
  )
}

FaqsSection.propTypes = {
  make: PropTypes.string,
  model: PropTypes.string,
  makeModelFaqs: PropTypes.shape({
    faqs: PropTypes.object,
    seoFaqs: PropTypes.object
  })
}
